function loadSliders() {
	$('.testimonials__inner .carousel-inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 3,
		prevArrow: "<button class='testimonials__button testimonials__button--prev' aria-label='Previous' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1783956022/Sites/jump-4-joy/arrow-yellow.png' alt=''/></button>",
		nextArrow: "<button class='testimonials__button testimonials__button--next' aria-label='Next' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1783956022/Sites/jump-4-joy/arrow-yellow.png' alt=''/></button>",
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});

	$('.gallery__inner').slick({
		centerMode: false,
		centerPadding: '0',
		slidesToShow: 6,
		prevArrow: "<button class='gallery__button gallery__button--prev' aria-label='Previous' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1783956022/Sites/jump-4-joy/arrow-yellow.png' alt=''/></button>",
		nextArrow: "<button class='gallery__button gallery__button--next' aria-label='Next' type='button'><img src='https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1783956022/Sites/jump-4-joy/arrow-yellow.png' alt=''/></button>",
		autoplay: true,
		autoplaySpeed: 5000,
		responsive: [
			{
				breakpoint: 1000,
				settings: {
					slidesToShow: 4
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 2
				}
			}
		]
	});
}

var sliderScript = document.getElementById("deferredSlickScript");

sliderScript.addEventListener('load', function () {
	loadSliders();
});

$(document).ready(function () {
	const bannerContainer = document.querySelector(".banner");
	let video;
	function startVideo() {
		if (!bannerContainer) return;

		video = document.createElement('video');
		video.src = "https://bouncycastlenetwork-res.cloudinary.com/video/upload/v1783957130/Sites/jump-4-joy/Jump-4-Joy.mp4";

		// iOS autoplay requirements
		video.muted = true;
		video.playsInline = true;
		video.setAttribute('playsinline', '');
		video.setAttribute('webkit-playsinline', '');
		video.setAttribute('muted', '');

		// Other config
		video.autoplay = true;
		video.loop = true;
		video.controls = false;
		video.preload = 'auto';
		video.poster = 'https://bouncycastlenetwork-res.cloudinary.com/image/upload/v1789979115/Sites/jump-4-joy/poster.png';

		bannerContainer.appendChild(video);

		// Try to start playback; handle iOS promise behavior
		const tryPlay = () => {
			const playPromise = video.play();
			if (playPromise && typeof playPromise.then === 'function') {
				playPromise.catch(() => {
					const resumeOnGesture = () => {
						video.play().catch(() => { /* swallow */ });
						document.removeEventListener('touchstart', resumeOnGesture);
						document.removeEventListener('click', resumeOnGesture);
					};
					document.addEventListener('touchstart', resumeOnGesture, { once: true, passive: true });
					document.addEventListener('click', resumeOnGesture, { once: true });
				});
			}
		};
		if ('oncanplay' in video) {
			video.addEventListener('canplay', tryPlay, { once: true });
		} else {
			// Fallback in case canplay is not fired
			setTimeout(tryPlay, 0);
		}
	}
	window.addEventListener('DOMContentLoaded', startVideo);
	window.addEventListener('load', () => {
		if (video && video.paused) {
			video.play().catch(() => { /* handled via gesture fallback */ });
		}
	});

	$('.textContent a').addClass("has-tooltip");

	$("img.has-tooltip").tooltip({
		title: function () {
			return $(this).attr("alt");
		},
		placement: "auto"
	});

	$("a.has-tooltip").tooltip({
		placement: "auto"
	});


	// lazyload bg images - trigger needs data-sal="" attribute
	//var promisesBgTrigger = document.getElementById("lazyload-bg-trigger");
	//promisesBgTrigger.addEventListener('sal:in', () => {
	//	$('.bg-element').css("background-image", "url(" + CloudUrl + "bg-image.jpg)");
	//});

	

	// ADD SLIDEDOWN ANIMATION TO DROPDOWN //
	$('.toplinks').on('show.bs.dropdown', function (e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideDown();
		$("#TopLinksInner .dropdown-menu a").addClass("animated");
		window.scrollBy(0, 1);
	});

	// ADD SLIDEUP ANIMATION TO DROPDOWN //
	$('.toplinks').on('hide.bs.dropdown', function (e) {
		$(this).find('.dropdown-menu').first().stop(true, true).slideUp();
	});


	if ($('#HomepageMarker').length > 0) {

		// this removes the '/' between testimonial author & date if there are any testimonials
		// its difficult to style otherwise & is rarely wanted.
		var testimonialAuthors = $(".RotatorTestimonialContent a[itemprop='author']");
		if (testimonialAuthors.length > 0) {
			$(".RotatorTestimonialContent a[itemprop='author']").each(function () {
				$(this)[0].nextSibling.nodeValue = '';
			});
		}
		//$('.RotatorTestimonialContent').prepend('<div class="testimonials__stars"><img class="LazyLoadImage" data-src="/theme/stars.png" alt="" /></div>');

		// this is handy for staggered animations...
		// $('.many').each(function (i, el) {
		//	$(el).addClass('fadeInUp2').attr('some-attr', i / 5 + 's').attr('some-attr', '150');
		// });

		$('.header__logo').addClass("fadeInUp2");
	} else {
		$('.header__logo').css('visibility', 'visible');
	}

	function fixHeights() {
		$('.RotatorTestimonialContent').sameHeight();
		$('.featured-categories__title').sameHeight();
		if (window.matchMedia('(min-width:768px)').matches) {

		}
	}

	setTimeout(fixHeights, 300);


	$(window).on('resize',
		function () {
			setTimeout(fixHeights, 300);
		});


	//uncomment if sal.js in use & animations have been added after page load
	//scrollAnimations.update();
});

